import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Table.module.styl";

function HeaderCell({ column }) {
    return (
        <th className={styles.headerCell} style={{ width: column.width }}>
            {column.title}
        </th>
    );
}

function Cell({ column, data, rowIndex, cellPadding }) {
    let content = null;
    if (column.dataProperty) {
        content = data[column.dataProperty];
    } else if (column.dataSelector) {
        content = column.dataSelector(data, rowIndex + 1);
    }

    return <td className={cx(styles.cell, styles["cellPadding_" + cellPadding])}>{content}</td>;
}

function Table({ columns, data, name, className, cellPadding, stripeFirstRow }) {
    return (
        <table className={cx(styles.table, className)} data-test-name={name}>
            <thead>
                <tr>
                    {columns.map((c, index) => (
                        <HeaderCell key={index} column={c} />
                    ))}
                </tr>
            </thead>

            <tbody className={styles.body}>
                {stripeFirstRow && <tr className={styles.row} />}

                {data.map((d, rowIndex) => (
                    <tr key={rowIndex} className={styles.row}>
                        {columns.map((col, index) => (
                            <Cell
                                key={index}
                                column={col}
                                data={d}
                                rowIndex={rowIndex}
                                cellPadding={cellPadding}
                            />
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}

Table.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.node,
            width: PropTypes.string,
            dataProperty: PropTypes.string,
            dataSelector: PropTypes.func,
        }),
    ).isRequired,

    name: PropTypes.string,
    data: PropTypes.array.isRequired,

    cellPadding: PropTypes.oneOf(["small", "big"]),
    stripeFirstRow: PropTypes.bool,
    className: PropTypes.string,
};

Table.defaultProps = {
    cellPadding: "big",
};

export default Table;
